import { Link, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const ICONS = {
    traveler: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
        </svg>
    ),
    partner: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 21h18" />
            <path d="M5 21V7l7-4 7 4v14" />
            <path d="M9 21v-6h6v6" />
        </svg>
    ),
};

export default function SiteSwitch() {
    const { t } = useI18n();
    const { pathname } = useLocation();
    const isPartner = pathname.startsWith("/partner");
    const tabs = [
        { to: "/", label: t("switch.travellers"), icon: ICONS.traveler, active: !isPartner, testid: "site-switch-turista" },
        { to: "/partner", label: t("switch.operators"), icon: ICONS.partner, active: isPartner, testid: "site-switch-partner" },
    ];
    return (
        <div
            data-testid="site-switch"
            role="navigation"
            aria-label={t("switch.aria")}
            className="itly-site-switch"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 2,
                padding: 3,
                borderRadius: 999,
                background: "var(--itly-surface)",
                border: "1px solid rgba(15, 61, 62, 0.16)",
                boxShadow: "0 3px 10px rgba(15, 61, 62, 0.08)",
            }}
        >
            {tabs.map((tab) => (
                <Link
                    key={tab.to}
                    to={tab.to}
                    data-testid={tab.testid}
                    aria-current={tab.active ? "page" : undefined}
                    className={tab.active ? "itly-site-switch-tab-active" : "itly-site-switch-tab-inactive"}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "6px 12px",
                        borderRadius: 999,
                        textDecoration: "none",
                        background: tab.active ? "var(--itly-teal-900)" : "transparent",
                        color: tab.active ? "var(--itly-on-teal)" : "var(--itly-fg-strong)",
                        fontFamily: "Inter, sans-serif",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: "0.02em",
                        whiteSpace: "nowrap",
                        transition: "background 180ms ease, color 180ms ease",
                    }}
                >
                    {tab.icon}
                    <span className="itly-site-switch-label">{tab.label}</span>
                </Link>
            ))}
        </div>
    );
}
